import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate() {
    const url = new URL(window.location);
    url.searchParams.set("per", this.element.value);
    window.location = url;
  }
}
